import {
  InputWrapper,
  InputWrapperProps,
  TextAreaProps,
  TextArea,
} from "@certn/cascadia-react";
import { useField } from "formik";
import { useState } from "react";

interface Props extends TextAreaProps, InputWrapperProps {
  name: string;
  label: string;
  info?: React.ReactNode;
  testID: string;
  description?: string;
}

const parseEmails = (input: string) => {
  return input
    .trim()
    .split(",")
    .reduce<string[]>((prev, curr) => {
      return [...prev, ...curr.split(" ")];
    }, [])
    .filter(Boolean);
};

export function EmailListField(props: Props) {
  const {
    name,
    span = "auto",
    testID = "email-list-area-field",
    label = "Recipient email(s)",
    description,
    isDisabled,
    isRequired,
  } = props;
  const [field, meta, helpers] = useField(name);
  const [text, setText] = useState(field.value.join(","));

  return (
    <InputWrapper span={span}>
      <TextArea
        name={name}
        isInvalid={Boolean(meta.touched && meta.error)}
        errors={meta.touched ? meta.error : undefined}
        label={label}
        onChange={(value: string) => {
          setText(value);
          helpers.setValue(parseEmails(value));
        }}
        onBlur={() => helpers.setTouched(true)}
        testID={testID}
        value={text}
        isRequired={isRequired}
        isDisabled={isDisabled}
        description={description}
      />
    </InputWrapper>
  );
}
